import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tool/page.tsx");
